import { Bell, ChevronUp, MessageCircle, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBntAsistente } from "@/modules/asistente/BntAsistenteContext";

function dockSummary(summary) {
  const parts = [];
  const alerts = Number(summary?.alertsCount || 0);
  const chat = Number(summary?.teamChatHintCount || 0);
  const client = Number(summary?.clientMessagesCount || 0);
  if (alerts > 0) parts.push(`${alerts} alerta${alerts === 1 ? "" : "s"}`);
  if (chat > 0) parts.push(`${chat} chat interno`);
  if (client > 0) parts.push(`${client} mensaje${client === 1 ? "" : "s"} cliente`);
  return parts.length ? parts.join(" · ") : "Sin pendientes";
}

/**
 * Barra de tareas integrada (dock) — el asistente minimizado sigue visible en la app.
 * No hay botón de cerrar: solo restaurar (permanece activo para el equipo).
 */
export default function BntAsistenteDock() {
  const {
    panelState,
    summary,
    badgeTotal,
    openPanel,
    activeTab,
    unreadTabs,
  } = useBntAsistente();

  const hasUnread = badgeTotal > 0 || Object.keys(unreadTabs || {}).length > 0;

  if (panelState !== "minimized") return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[45] flex justify-center px-3 pb-2 pointer-events-none"
      data-testid="bnt-asistente-dock"
    >
      <div className="pointer-events-auto flex w-full max-w-3xl items-center gap-2 rounded-t-md border border-slate-200 border-b-0 bg-white px-3 py-2 shadow-[0_-8px_24px_rgba(15,45,92,0.12)]">
        <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#0F2D5C] text-white relative ${
          hasUnread ? "ring-2 ring-rose-500 animate-pulse" : ""
        }`}>
          <MessageCircle className="h-4 w-4" aria-hidden />
          {badgeTotal > 0 ? (
            <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-rose-600 text-white text-[9px] font-bold flex items-center justify-center">
              {badgeTotal > 99 ? "99+" : badgeTotal}
            </span>
          ) : null}
        </div>

        <button
          type="button"
          className="min-w-0 flex-1 text-left"
          onClick={() => openPanel({ tab: activeTab })}
          data-testid="bnt-asistente-dock-restore"
        >
          <p className="text-xs font-semibold text-[#0F2D5C] m-0 truncate">BNT Asistente</p>
          <p className="text-[10px] text-slate-500 m-0 truncate flex items-center gap-2">
            <span className="inline-flex items-center gap-1">
              <Bell className="h-3 w-3" aria-hidden />
              {summary?.alertsCount || 0}
            </span>
            <span className="inline-flex items-center gap-1">
              <MessageSquare className="h-3 w-3" aria-hidden />
              {(summary?.teamChatHintCount || 0) + (summary?.clientMessagesCount || 0)}
            </span>
            <span className="truncate">{dockSummary(summary)}</span>
          </p>
        </button>

        <Button
          type="button"
          size="sm"
          className="rounded-sm h-8 bg-[#0F2D5C] hover:bg-[#0a2248] shrink-0"
          onClick={() => openPanel({ tab: activeTab })}
          data-testid="bnt-asistente-dock-open"
        >
          <ChevronUp className="h-4 w-4 mr-1" aria-hidden />
          Restaurar
        </Button>
      </div>
    </div>
  );
}
